(function(){
  const section=document.querySelector('.vl-pfs');
  if(!section)return;
  const grid=section.querySelector('[data-pfs-grid]');
  const empty=section.querySelector('[data-pfs-empty]');
  const search=section.querySelector('[data-pfs-search]');
  const specialty=section.querySelector('[data-pfs-specialty]');
  const source=section.getAttribute('data-source')||'profesionales.json';
  const format=(section.getAttribute('data-format')||'auto').toLowerCase();
  let professionals=[];

  const esc=(value)=>String(value||'').replace(/[&<>'"]/g,(char)=>({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#039;','"':'&quot;'}[char]));
  const normalize=(value)=>String(value||'').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'').trim();
  const clean=(value)=>String(value||'').trim();

  function detectFormat(url,contentType){
    if(format==='json'||format==='csv'||format==='tsv')return format;
    if(contentType&&contentType.includes('json'))return 'json';
    if(contentType&&contentType.includes('tab-separated'))return 'tsv';
    if(url.includes('output=csv')||url.includes('tqx=out:csv')||url.endsWith('.csv'))return 'csv';
    if(url.endsWith('.tsv'))return 'tsv';
    return 'json';
  }

  function parseDelimited(text,delimiter){
    const rows=[];
    let row=[];
    let cell='';
    let insideQuotes=false;
    for(let i=0;i<text.length;i++){
      const char=text[i];
      const next=text[i+1];
      if(char==='"'){
        if(insideQuotes&&next==='"'){
          cell+='"';
          i++;
        }else{
          insideQuotes=!insideQuotes;
        }
      }else if(char===delimiter&&!insideQuotes){
        row.push(cell);
        cell='';
      }else if((char==='\n'||char==='\r')&&!insideQuotes){
        if(char==='\r'&&next==='\n')i++;
        row.push(cell);
        if(row.some((value)=>clean(value)!==''))rows.push(row);
        row=[];
        cell='';
      }else{
        cell+=char;
      }
    }
    row.push(cell);
    if(row.some((value)=>clean(value)!==''))rows.push(row);
    return rows;
  }

  function rowsToObjects(rows){
    if(!rows.length)return [];
    const headers=rows[0].map((h)=>normalize(h).replace(/\s+/g,'_'));
    return rows.slice(1).map((row)=>{
      const item={};
      headers.forEach((header,index)=>{item[header]=clean(row[index]);});
      return {
        nombre:item.nombre||item.name||'',
        especialidad:item.especialidad||item.specialty||'',
        cedula:item.cedula||item.cedula_profesional||item.cedula_profesional||item.license||'',
        foto:item.foto||item.fotografia||item.imagen||item.photo||item.image||'',
        contacto:item.contacto||item.contacto_publico||item.whatsapp||item.email||item.url||'',
        semblanza:item.semblanza||item.bio||item.biografia||item.descripcion||item.description||'',
        badge:item.badge||item.etiqueta||item.rol||'Profesional de la salud',
        publicar:item.publicar||item.visible||item.activo||'si'
      };
    }).filter((item)=>item.nombre&&['si','sí','yes','true','1','publicar','activo',''].includes(normalize(item.publicar)));
  }

  function card(item){
    const image=item.foto||'https://placehold.co/900x900/f5faff/022054?text=VidaLabs';
    const cedula=item.cedula?`<div class="vl-pfs-card__cedula">
                                Cédula: ${esc(item.cedula)}
                              </div>`:'';
    const semblanza=clean(item.semblanza||item.bio||item.biografia||item.descripcion||item.description)
      ?`<p class="vl-pfs-card__semblance">
          ${esc(item.semblanza||item.bio||item.biografia||item.descripcion||item.description)}
        </p>`:'';
    const contact=item.contacto?`<a class="vl-pfs-card__contact" href="${esc(item.contacto)}" target="_blank" rel="noopener">
                                  Contactar
                                </a>`:`<div class="vl-pfs-card__no-contact" style="display:none">Contacto no disponible públicamente</div>`;
    return `<article class="vl-pfs-card">
              <div class="vl-pfs-card__photo">
                <img src="${esc(image)}" alt="Foto de ${esc(item.nombre)}" loading="lazy">
              </div>
              <div class="vl-pfs-card__body">
                <h3>${esc(item.nombre)}</h3>
                  <div class="vl-pfs-card__specialty">
                    ${esc(item.especialidad)}
                  </div>
                  ${cedula}
                  ${semblanza}
                  ${contact}
              </div>
            </article>`;
  }

  function populateFilters(){
    const specialties=[...new Set(professionals.map((p)=>p.especialidad).filter(Boolean))].sort((a,b)=>a.localeCompare(b,'es'));
    specialty.innerHTML='<option value="">Todas</option>'+specialties.map((s)=>`<option value="${esc(s)}">${esc(s)}</option>`).join('');
  }

  function render(){
    const q=normalize(search.value);
    const s=normalize(specialty.value);
    const filtered=professionals.filter((p)=>{
      const haystack=normalize(`${p.nombre} ${p.especialidad} ${p.cedula} ${p.semblanza||''}`);
      return (!q||haystack.includes(q))&&(!s||normalize(p.especialidad)===s);
    });
    grid.innerHTML=filtered.map(card).join('');
    empty.hidden=filtered.length>0;
  }

  fetch(source,{cache:'no-store'})
    .then(async(r)=>{
      if(!r.ok)throw new Error('No se pudo cargar la base de datos');
      const responseFormat=detectFormat(source,r.headers.get('content-type')||'');
      if(responseFormat==='json')return r.json();
      const text=await r.text();
      return rowsToObjects(parseDelimited(text,responseFormat==='tsv'?'\t':','));
    })
    .then((data)=>{
      professionals=Array.isArray(data)?data:[];
      populateFilters();
      render();
    })
    .catch(()=>{
      professionals=[];
      render();
      empty.hidden=false;
      empty.textContent='No se pudo cargar la información de profesionales.';
    });

  search.addEventListener('input',render);
  specialty.addEventListener('change',render);
})();
